import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { withTranslation } from 'react-i18next';
import withCustomComponent from 'ui/components/withCustomComponent';

@withCustomComponent('CardDashboard')
@withTranslation()
class CardDashboard extends Component {
  static propTypes = {
    headerMainTitle: PropTypes.string.isRequired,
    headerActionTitle: PropTypes.string,
    headerActionUrl: PropTypes.string,
    footerActionTitle: PropTypes.string,
    footerActionIcon: PropTypes.string,
    footerActionUrl: PropTypes.string,
    componentName: PropTypes.string,
  };

  render() {
    const {
      t,
      headerMainTitle,
      headerActionTitle, headerActionUrl,
      footerActionTitle, footerActionIcon, footerActionUrl,
      componentName
    } = this.props;

    return (
      (<div
              data-component-name={componentName}
              className="card card-dashboard"
            >
        <div className="card-dashboard__header">
          {headerMainTitle &&
            <h6 className="m-0">{headerMainTitle}</h6>
          }
          {(headerActionTitle && headerActionUrl) &&
            <Link
              href={headerActionUrl}
              className="btn btn-link fs-14 text-gray-900"
              >
              {headerActionTitle}
            </Link>
          }
        </div>
        <div className="card-dashboard__content">
          {this.props.children}
        </div>
        <div className="card-dashboard__footer">
          {(footerActionTitle && footerActionUrl) &&
            <Link
              href={footerActionUrl}
              className={`btn btn-sm ${footerActionIcon ? 'btn-icon' : ''}`}
              >

              {footerActionIcon &&
                <i className={footerActionIcon}></i>
              }
              {footerActionTitle}

            </Link>
          }
        </div>
      </div>)
    );
  }
}

export default CardDashboard;
